import React, { useState } from "react";
import styles from "../../../assets/scss/Billing/AddBilling.module.scss";
import { useReturnAssetMutation } from "../../../slices/admin/admin";
import { toast } from "react-toastify";

const AssetAddForm = ({ onClose, userId }) => {
  const [paymentType, setPaymentType] = useState("");
  const [boxCount, setBoxCount] = useState("");
  const [sackCount, setSackCount] = useState("");
  const [errors, setErrors] = useState({});

  const [returnAsset, { isLoading }] = useReturnAssetMutation();

  const validate = () => {
    let newErrors = {};

    if (!paymentType) newErrors.paymentType = "Asset Type is required";

    if (paymentType === "Cash") {
      if (!boxCount || Number(boxCount) <= 0)
        newErrors.boxCount = "Box Count must be greater than 0";
    }

    if (paymentType === "UPI") {
      if (!sackCount || Number(sackCount) <= 0)
        newErrors.sackCount = "Sack Count must be greater than 0";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      await returnAsset({
        userId,
        data: {
          sackCount: paymentType === "UPI" ? Number(sackCount) : 0,
          boxCount: paymentType === "Cash" ? Number(boxCount) : 0,
        },
      }).unwrap();

      toast.success("Asset returned successfully");
      onClose();
    } catch (err) {
      toast.error(err?.data?.message || "Failed to return asset");
    }
  };

  return (
    <div>
      <div className={styles.header}>
        <h2 className={styles.tittle}>Box & Sack Debit</h2>
        <span className={styles.closeIcon} onClick={onClose}>✕</span>
      </div>

      <div className={styles.AddLedgerEntryformSection}>
        <div className={styles.ownerinput}>
          <label className={styles.inputLabelssss}>
            Asset Type <span style={{ color: "red" }}>*</span>
          </label>

          <select
            className={`${styles.inputsheader} ${errors.paymentType ? styles.inputError : ""}`}
            value={paymentType}
            onChange={(e) => {
              setPaymentType(e.target.value);
              setBoxCount("");
              setSackCount("");
              setErrors({});
            }}
          >
            <option value="">Select Asset Type</option>
            <option value="Cash">Box Return</option>
            <option value="UPI">Sack Return</option>
          </select>

          {errors.paymentType && (
            <p className={styles.errorText}>{errors.paymentType}</p>
          )}
        </div>

        {paymentType === "Cash" && (
          <div className={styles.ownerinput}>
            <label className={styles.inputLabelssss}>
              Box Count <span style={{ color: "red" }}>*</span>
            </label>

            <input
              type="number"
              value={boxCount}
              onChange={(e) => setBoxCount(e.target.value)}
              className={styles.inputlastone}
              placeholder="Enter Box Count"
            />
            {errors.boxCount && (
              <p className={styles.errorText}>{errors.boxCount}</p>
            )}
          </div>
        )}

        {paymentType === "UPI" && (
          <div className={styles.ownerinput}>
            <label className={styles.inputLabelssss}>
              Sack Count <span style={{ color: "red" }}>*</span>
            </label>

            <input
              type="number"
              value={sackCount}
              onChange={(e) => setSackCount(e.target.value)}
              className={styles.inputlastone}
              placeholder="Enter Sack Count"
            />
            {errors.sackCount && (
              <p className={styles.errorText}>{errors.sackCount}</p>
            )}
          </div>
        )}
      </div>

      <div className={styles.ownerinputs}>
        <button className={styles.cancelBtnlast} onClick={onClose}>
          Cancel
        </button>
        <button
          className={styles.saveBtnlast}
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? "Processing..." : "Return"}
        </button>
      </div>
    </div>
  );
};

export default AssetAddForm;